var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 57,
  height: 22,
  viewBox: "0 0 57 22"
}, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#528AEA",
  fillRule: "evenodd",
  fontFamily: "Proximanova-Bold, Proxima Nova Alt",
  fontSize: 30,
  fontWeight: "bold",
  transform: "translate(-52 -22)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 51.869,
  y: 43
}, "TEG"))));
export default __webpack_public_path__ + "teg/media/teg.c2e7b7c1.svg";
export { SvgComponent as ReactComponent };